import { HTMLProps } from 'react';
import './html-renderer.css';

type THtmlRendererProps = HTMLProps<HTMLDivElement>;

export const HtmlRenderer = (props: THtmlRendererProps) => <div {...props} className="html-renderer" />;
